// import URI from 'jssip/lib-es5/URI';
export const stringToUriObject = (uri, ua) => {
    const normalizedUri = ua.normalizeTarget(uri);
    //   const uriObject = new URI(
    //     normalizedUri.scheme,
    //     normalizedUri.user,
    //     normalizedUri.host,
    //     normalizedUri.port,
    //   );
    return normalizedUri;
};
